<template>
  <div class="productTableHeader">
    <v-data-table
      :headers="tableHeaders"
      :items="items"
      :item-key="itemKey"
      :hide-default-header="false"
      hide-default-footer
      class="rounded-lg"
      :items-per-page="-1"
      :no-data-text="$t('common.common_no-history')"
    >
      <template v-slot:item.productName="{ item }">
        <slot name="productName" v-bind:item="item"></slot>
      </template>
      <template v-slot:item.quantityDate="{ item }">
        <slot name="quantityDate" v-bind:item="item"></slot>
      </template>
      <template v-slot:item.stockQuantity="{ item }">
        <slot name="stockQuantity" v-bind:item="item"></slot>
      </template>
      <template v-slot:item.productCapacity="{ item }">
        <slot name="productCapacity" v-bind:item="item"></slot>
      </template>
    </v-data-table>
    <slot name="expandFooter"></slot>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { productMovesUtil, saleUtil, orderUtil, commonUtil } from '@/util'

import TotalAmount from '@/components/items/Designs/TotalAmount/TotalAmount'
import { ProductTable } from '@/components/items'
import saleHeadersHistory from '@/views/sales/History/headers'
import orderHeadersHistory from '@/views/order/History/headers'
import { currencyUtil } from '@/util'

export default {
  name: 'ShipDeliveryContentTable',
  components: {
    ProductTable,
    TotalAmount
  },
  props: {
    items: {
      type: Array,
      require: true,
      default: () => ({})
    },
    headers: {
      type: Array,
      require: true,
      default: () => []
    },
    itemKey: String,
    type: {
      type: String,
      require: true,
      default: () => ''
    },
    isEdit: { default: false },
    isTotalAmount: { default: true }
  },
  data: () => ({
    recDetail: {
      productListHeaders: []
    },

    totalList: {
      taxFree: 0,
      tax10: {
        totalAmount: 0,
        tax: 0
      },
      tax8: {
        totalAmount: 0,
        tax: 0
      },
      discount: 0,
      shipping: 0,
      totalAmount: 0,
      unitName: ''
    }
  }),
  created() {},
  methods: {
    getObjectByType() {
      switch (this.type) {
        case 'order':
          return [orderUtil, orderHeadersHistory]
        case 'sale':
          return [saleUtil, saleHeadersHistory]
      }
    },

    getCurrencyName(productInfo) {
      const currencyId = productInfo.currencyId
      if (currencyId) {
        return currencyUtil.findCurrencyNameById(currencyId).unitName
      }
      return ''
    },
    formatPrice(price) {
      return commonUtil.formatPrice(price)
    }
  },
  computed: {
    ...mapGetters('User', ['authority']),
    tableHeaders() {
      if (!Array.isArray(this.headers)) {
        return []
      }
      const headersTmp = this.headers.map((header) => {
        if (!this.isOperation) {
          if (header.value === 'operationId') {
            header.text = ''
            header.value = 'noDisplay'
          }
        }
        const tmp = { ...header }
        tmp.text = this.$t(tmp.text)
        return tmp
      })
      return headersTmp
    },
    isOrder() {
      return this.type === 'order'
    },
    isCurrencyJpn() {
      return this.items.currencyId === 1
    }
  }
}
</script>
<style scoped lang="scss">
.productTableHeader {
  ::v-deep .v-data-table th {
    background-color: rgba(151, 198, 234, 0.1) !important;
    border-collapse: collapse;
    text-align: center !important;
    white-space: pre-wrap;
    background-color: #fafafb;

    border-bottom: 1px solid #d8d8d8;
    border-right: 1px solid #d8d8d8;
  }
  ::v-deep .v-data-table td {
    border-collapse: collapse;

    border-bottom: 1px solid #d8d8d8;
    border-right: 1px solid #d8d8d8;
    border-spacing: 0;
    margin: -1px;
  }
}
.totalAmountStyle {
  width: 100%;
  margin: auto;
}
</style>
